import { gql } from '@apollo/client';
import { DecoratedFormProps } from 'redux-form';
import { Dispatch } from 'redux';

import {
  ForgottenPasswordRequestFormFields,
  ForgottenPasswordRequestFormProps,
} from 'components/forms/ForgottenPasswordRequestForm/types';
import {
  AsyncValidate_forgottenPasswordRequestFormQuery,
  AsyncValidate_forgottenPasswordRequestFormQueryVariables,
} from 'types/graphql';

import { apolloClient } from '../../lib/apollo/withApollo';

const ASYNC_VALIDATE_FORGOTTEN_PASSWORD_REQUEST_FORM_QUERY = gql`
  query AsyncValidate_forgottenPasswordRequestFormQuery($email: String!) {
    emailExists(email: $email)
  }
`;

export default async (
  fields: ForgottenPasswordRequestFormFields,
  dispatch: (dispatch: Dispatch) => void,
  props: DecoratedFormProps<unknown, ForgottenPasswordRequestFormProps>,
): Promise<{ email: string } | undefined> => {
  const { data } = await apolloClient().query<
    AsyncValidate_forgottenPasswordRequestFormQuery,
    AsyncValidate_forgottenPasswordRequestFormQueryVariables
  >({
    query: ASYNC_VALIDATE_FORGOTTEN_PASSWORD_REQUEST_FORM_QUERY,
    variables: { email: fields.email },
  });

  if (data.emailExists === false) {
    return {
      email: props.t('forgottenPasswordRequestForm.asyncErrors.emailNotFound'),
    };
  }
};
